// Selectors for HTML element triggers for Yext global search
const searchSelectors = [
  '#navSearch',
  '#home-cta-grid .search-line',
  '#hero-split-home-search-button',
  '#hero-split-home-search-button svg',
  '#main-nav-search-button',
  // '#main-nav-search-button svg', //nested elements will bubble up to parent
  '#main-nav-search-button-mobile button'
];

//checks if the hostname contains a string
const hostnameMatch = function(str){
  let hostname = document.location.hostname;
  const match = hostname.match(str);

  return match !== null && match.length > 0;
}

// Handles opening the search link if there's a different subdomain
const openSearch = function(event) {
  let searchLink = "https://search.ochsner.org/";

  if(hostnameMatch('blog')) {
    searchLink = searchLink + "?verticalKey=article";
  } else if (hostnameMatch('news')) {
    searchLink = searchLink + "?verticalKey=news";
  } else if (hostnameMatch('research')) {
    searchLink = searchLink + "?verticalKey=research";
  } else if (hostnameMatch('education')) {
    searchLink = searchLink + "?verticalKey=education";
  } else if (hostnameMatch('calendar')) {
    searchLink = searchLink + "?verticalKey=event";
  }

  location.href = searchLink;
}

// Iterate over all selectors and set event listeners to open links to search
for (let i = 0; i < searchSelectors.length; i++) {
  let selector = searchSelectors[i];
  let element = document.querySelector(selector);
  if(element) {
    element.addEventListener('click', function(event) {
      event.preventDefault();
      openSearch(event);
    });
  }
}
